import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PageSelectors } from '../../../../../redux/reducers/pageSlice';
import { LoaderTypes } from '../../../../../utils/@globalTypes';
import { TariffsSelectors } from '../../../../../redux/reducers/tariffsSlice';
import Loader from '../../../../../components/Loader';
import { TarifTypes } from '../../../../../redux/types/@types';
import UnavailableContent from '../../../../../components/UnavailableContent';
import FeedingSettings from '../FeedingSettings';
import {
  getFeedingSettings,
  MainObjectSelectors,
} from '../../../../../redux/reducers/mainObjectSlice';
import { useParams } from 'react-router-dom';

const FeedingWrap = () => {
  const isLoading = useSelector(
    PageSelectors.getLoadersData(LoaderTypes.FEEDING_PAGE),
  );
  const dispatch = useDispatch();
  const currentTarif = useSelector(TariffsSelectors.getCurrentTarif);
  const { id } = useParams();
  useEffect(() => {
    if (id && currentTarif && currentTarif !== TarifTypes.FREE)
      dispatch(getFeedingSettings(id));
  }, [currentTarif, id]);

  const settings = useSelector(MainObjectSelectors.getFeedingSetting);

  return isLoading || !currentTarif ? (
    <Loader />
  ) : currentTarif === TarifTypes.FREE ? (
    <UnavailableContent />
  ) : (
    settings && <FeedingSettings settings={settings} />
  );
};

export default FeedingWrap;
